export * from "./Divider.settings";
